import { render, staticRenderFns } from "./displayDetailDialog.vue?vue&type=template&id=ceb1cc9e&"
import script from "./displayDetailDialog.vue?vue&type=script&lang=js&"
export * from "./displayDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports